<template lang="pug">
.exchange-container(
  v-show="info.length > 0"
  :class="{ 'new-module': newModule, 'new-style': newStyle, 'pure-version': pureVersion }"
)
  exchange(
    ref="exchange",
    :amount="bounty",
    :points="points"
    :refresh="false",
    @bounty="$emit('bounty')",
    page-id="Welfare"
  )
  //- 新版兑换弹窗
  ExchangePopup(
    :visible="exchangePopupVisible"
    :exchangeInfo="currentExchangeInfo"
    :points="points"
    :isShowGroupPayment="isShowGroupPayment"
    @close="handleExchangePopupClose"
    @success="handleExchangeSuccess"
    :pureVersion="pureVersion"
    @bounty="$emit('bounty')"
    @earnPoints="handleEarnPoints"
    :popupSource=1
  )


  .exchange-header(v-if="newStyle")
    img.header-title(
      src="https://m.hellobike.com/resource/gallery/833/69mFcmLC_b.png"
      alt=""
    )
    .my-coupon-btn(@click="goMyCoupon")
      span 我兑换的券
      img.arrow-icon(
        src="https://m.hellobike.com/resource/gallery/3/YsSIswNW_title-info.png"
        alt=""
      )
  .header(v-else) {{moduleTitle}}
  .body
    .tabs
      template(v-for="(item, index) in tabs")
        .tab(@click="changeTab(index)", :class="{ active: index === active }") {{ item.name }}
    .shadow
    .exchange-list-content
      quark-list(
        @load="onLoad"
        :loading="loading"
        :finished="!hasMore[active]"
        :finishedtext="finishedtext"
        :offset="1"
      )
        div(slot="content")
          template(v-if="items && items.length > 0")
            .exchange-items(:class="{'new-flex': newStyle}")
              template(v-for="item in items")
                .exchange-item(v-if="!newStyle")
                  .left-container(@click="goDetail(item)")
                    .left.column
                      img(:src="item.image", alt="cover")
                    .mid.column
                      .title {{ item.title }}
                      .subtitle {{ item.subtitle }}
                      .desc
                        span 已兑{{ item.soldNum }}件
                  .right.column
                    template(v-if="newModule")
                      .btn.flex-mid(@click="onExchange(item)")
                        img.icon(
                          src="https://m.hellobike.com/resource/AppPlatformH5/fuli/McuKtqFNzr0bhHNNseHY8.png"
                        )
                        span {{ item.amount }}兑
                    template(v-else)
                      .title {{ newStyle? '' : '需' }}{{ item.amount }}奖励金
                      .btn.flex-mid(@click="onExchange(item)")
                        img.icon(
                          src="https://m.hellobike.com/resource/AppPlatformH5/fuli/McuKtqFNzr0bhHNNseHY8.png"
                        )
                        span 兑换
                .exchange-item-new(v-else)
                  ExchangeItemCard(
                    :item="item"
                    :coinIcon="coinIcon"
                    @detail="goDetail"
                    @exchange="onExchange"
                  )
          template(v-if="empty")
            Empty
</template>

<script>
import config from '@/const/config';
import Empty from '@/components/empty';
import LoadingItem from '@/components/loading-item';
import Toast from '@/components/toast';
import { jumpUrl } from '@/utils/tools';
import SPM from '../common/spm';
import {
  TABS,
  FULI_MODULE_NAV,
  WELFARE_VERSION,
  FULI_MODULE,
} from '../consts';
import Exchange from '../exchange/exchange';
import ExchangePopup from '../new-version-cpns/exchange-popup';
import ExchangeItemCard from '../components/exchange-item-card';
import { getExchangeList, welfareGoCoupon } from '../utils';
import 'quarkd/lib/list';

const mapper = ({
  itemName,
  virtualSalePrice,
  listItemUrl,
  soldNum,
  originalPrice,
  skuId,
  saleNum,
  virtualType,
  salePriceAfterDeduction,
  pointsDeduction,
  salePrice,
  itemId,
  promotionInfos,
}) => {
  // 兑换商品曝光
  SPM.moduleExpose({
    moduleId: 'Welfare_goods_sku',
    contentId: 'Welfare_goods_sku',
    businessInfo: {
      sku_name: itemName,
      exchangeNeedCash: salePriceAfterDeduction,
      exchangebonus: pointsDeduction,
      exchangeTotalBonus: virtualSalePrice,
      isSupportCash: !!(pointsDeduction && salePriceAfterDeduction),
    },
  });
  return {
    title: itemName,
    subtitle: originalPrice ? `价值${originalPrice}元` : '',
    amount: virtualSalePrice,
    image: listItemUrl,
    soldNum,
    cost: virtualSalePrice || 0,
    price: originalPrice || 0,
    skuId,
    saleNum,
    virtualType,
    salePriceAfterDeduction: salePriceAfterDeduction || 0,
    pointsDeduction: pointsDeduction || 0,
    salePrice,
    itemId,
    promotionInfos: promotionInfos && promotionInfos.map((item) => ({
      ...item,
      worth: item.deductionAmount,
    })),
  };
};

export default {
  components: {
    LoadingItem,
    Empty,
    Exchange,
    ExchangePopup,
    ExchangeItemCard,
  },
  props: {
    bounty: {
      type: Number,
      default: 0,
    },
    points: {
      type: Number,
      required: true,
    },
    tabs: {
      type: Array,
      default: () => TABS,
    },
    newModule: {
      type: Boolean,
      default: false,
    },
    pureVersion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageSize: 8,
      pageNums: [],
      active: 0,
      info: [],
      hasMore: [],
      loading: false,
      // 当前兑换信息
      currentExchangeInfo: {},
      // 兑换弹窗是否显示
      exchangePopupVisible: false,
      firstLoad: true,
      // 兑换弹窗是否展示为奖励金+钱组合支付的按钮
      isShowGroupPayment: false,
    };
  },
  inject: ['newTaskScene', 'taskScene'],
  computed: {
    newStyle() {
      return this.newTaskScene();
    },
    coinIcon() {
      return this.newStyle
        ? 'https://m.hellobike.com/resource/gallery/833/8TcECPUAyI.png'
        : 'https://m.hellobike.com/resource/AppPlatformH5/fuli/McuKtqFNzr0bhHNNseHY8.png';
    },
    current() {
      return {
        ...(this.tabs[this.active] || {}),
        pageNum: this.pageNums[this.active] || 1,
      };
    },
    items() {
      return this.info[this.active] || [];
    },
    moduleTitle() {
      if (this.newModule) {
        return '用奖励金';
      }
      return '奖励金兑换专区';
    },
    finishedtext() {
      if (!this.items || this.items.length === 0) return '';
      return this.hasMore[this.active] ? '' : '到底了';
    },
    // 无数据且不处于加载状态
    empty() {
      return (!this.items || this.items.length === 0) && !this.loading;
    },
  },
  watch: {
    tab(v) {
      this.active = Number(v);
    },
    tabs(v) {
      if (v && v.length > 0 && v.length !== this.tabs.length) {
        this.hasMore = new Array(v.length).fill(true);
      }
    },
    points() {
      this.refreshList();
    },
  },
  created() {
    if (this.tabs && this.tabs.length > 0) {
      this.hasMore = new Array(this.tabs.length).fill(true);

      // 获取当前选中的tab
      const { anchorModule, tab } = this.$route.query;
      if (anchorModule === FULI_MODULE.welfare_bountyExchange && tab) {
        const idx = this.tabs.findIndex((i) => i.type === tab);
        if (idx !== -1) {
          this.active = idx;
        }
      }
    }

    // 获取兑换商品列表
    this.getData();

    // 商品兑换模块曝光
    SPM.moduleExpose({
      moduleId: 'Welfare_goods',
      contentId: 'Welfare_goods',
      businessInfo: {
        tab_name: this.tabs.map((t) => t.name).join(','),
        type_tab: this.tabs?.[this.active]?.name || '',
      },
    });
  },
  methods: {
    goDetail(item) {
      if (item) {
        // 兑换商品点击埋点上报
        SPM.clickButton({
          buttonName: 'Welfare_goods_sku',
          businessInfo: {
            sku_name: item.title,
            exchangeNeedCash: item.salePriceAfterDeduction,
            exchangebonus: item.pointsDeduction,
            isSupportCash: !!(item.salePriceAfterDeduction && item.pointsDeduction),
            exchangeTotalBonus: item.cost,
          },
        });
        jumpUrl(
          `https://m.hellobike.com/AppPlatformH5/${
            config.env !== 'pro' ? `${config.env}/` : ''
          }latest/pr_index_bounty_detail_default.html#/bounty/detail/${
            item.skuId
          }?adsource=4`,
        );
      }
    },
    onExchange(item) {
      this.currentExchangeInfo = item;
      SPM.clickButton({
        buttonName: 'Welfare_goods_sku_button',
        businessInfo: {
          sku_name: item.title,
        },
      });

      const taskScene = this.taskScene();
      if (item.cost <= this.points) {
        this.isShowGroupPayment = false;
        if (taskScene === WELFARE_VERSION.NEW_TASK_SCENE_V2) {
          this.exchangePopupVisible = true;
        } else {
          this.$refs.exchange.doExchange({
            ...item,
            ...{ newModule: this.newModule },
          });
        }
      } else if (this.currentExchangeInfo.salePriceAfterDeduction > 0) {
        this.exchangePopupVisible = true;
        this.isShowGroupPayment = true;
      } else {
        Toast.show('奖励金不足，快去赚币吧');
      }
    },
    changeTab(index) {
      if (this.loading) return;
      SPM.clickButton({
        buttonName: 'Welfare_goods_tab',
        businessInfo: {
          clickTab: this.tabs[index].name,
          tab_name: this.tabs.map((t) => t.name).join(','),
          type_tab: this.tabs[this.active]?.name || '',
        },
      });
      this.active = index;
      if (this.info && this.info[index] === undefined && this.hasMore[index]) {
        this.getData();
      }
    },
    getData(...args) {
      getExchangeList(mapper)
        .call(this, ...args)
        .finally(() => {
          this.$emit('loaded');
          if (!this.info.length) {
            this.$emit('hideTab', FULI_MODULE_NAV.welfare_bountyExchange);
          }
        });
    },
    // 跳转优惠券
    goMyCoupon() {
      SPM.clickButton({
        buttonName: 'Welfare_goods_coupon',
        businessInfo: {},
      });
      welfareGoCoupon();
    },
    // 关闭兑换弹窗
    handleExchangePopupClose() {
      this.exchangePopupVisible = false;
    },
    // 确认兑换成功
    handleExchangeSuccess() {
      this.exchangePopupVisible = false;
    },
    // 重置并刷新商品列表
    refreshList() {
      this.info = [];
      this.pageNums = [];
      this.hasMore = new Array(this.tabs.length).fill(true);
      this.getData();
    },
    // 去赚币
    handleEarnPoints(num) {
      this.$emit('earnPoints', num);
    },
    onLoad() {
      if (this.loading) return;
      if (this.hasMore[this.active]) {
        this.getData();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-container {
  padding: 0.2rem 0 0.16rem 0.16rem;

  .header {
    font-size: 0.18rem;
    color: #242729;
    margin-bottom: 0.08rem;
    font-weight: 500;
  }

  .body {
    position: relative;

    .shadow {
      position: absolute;
      right: 0;
      top: 0.016rem;
      width: 0.16rem;
      height: 0.18rem;
      background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
    }
  }

  .more {
    font-size: 0.12rem;
    color: #999;
    margin-top: 0.21rem;

    * {
      border-color: #999 !important;
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.12rem;
    color: #ccc;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;

    img {
      width: 0.78rem;
      height: 0.68rem;
      margin-bottom: 0.08rem;
    }
  }

  .tabs {
    width: 100%;
    height: 0.3rem;
    overflow-x: scroll;
    overflow-y: visible;
    white-space: nowrap;
    padding-right: 0.1rem;
    margin-bottom: 0.08rem;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }

    .tab {
      flex: none;
      display: inline-block;
      font-size: 0.16rem;
      position: relative;
      color: #879099;
      font-weight: 400;

      &:not(:last-of-type) {
        margin-right: 0.18rem;
      }

      &.active {
        color: #242729;
      }

      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -0.04rem;
        width: 0;
        height: 0.03rem;
        background-color: #242729;
        border-radius: 0.02rem;
        transition: width 0.2s ease-in-out;
      }

      &.active::after {
        width: 0.18rem;
      }
    }
  }

  .exchange-list-content {
    min-height: calc(100vh - 1.6rem);
  }

  .exchange-items {
    padding-right: 0.15rem;
  }

  .exchange-item {
    display: flex;
    min-height: 0.56rem;
    align-items: center;
    justify-content: space-between;

    &:not(:last-of-type) {
      margin-bottom: 0.16rem;
    }

    .column {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .left-container {
      display: flex;
    }

    .left {
      img {
        width: 0.85rem;
        height: 0.51rem;
        border-radius: 0.04rem;
      }
    }

    .right {
      justify-content: center;
      align-items: center;

      .title {
        font-size: 0.1rem;
        font-weight: 400;
        color: #879099;
        margin-top: 0.03rem;
        margin-bottom: 0.02rem;
      }

      .btn {
        width: 0.7rem;
        height: 0.25rem;
        border-radius: 0.13rem;
        font-size: 0.12rem;
        font-weight: 500;
        color: #ff5526;
        border: 0.01rem solid #ff5526;

        .icon {
          width: 0.13rem;
          height: 0.13rem;
          margin-right: 0.02rem;
        }
      }
    }

    .mid {
      flex: 1;
      padding-left: 0.08rem;
      display: flex;
      height: 0.51rem;
      flex-direction: column;
      justify-content: space-between;

      .title {
        font-size: 0.14rem;
        font-weight: 500;
        color: #242729;
        max-width: 1.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .subtitle {
        font-size: 0.12rem;
        color: #879099;
        line-height: 1;
      }

      .desc {
        font-size: 0.1rem;
        font-weight: 500;
        color: #ff5526;
        line-height: 0.1rem;
        display: flex;
        align-items: center;
      }
    }
  }

  .new-flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .exchange-item-new {
    margin-bottom: 0.1rem;
  }

  &.new-module {
    padding: 0.16rem;

    .header {
      margin-bottom: 0.04rem;
      font-size: 0.16rem;
    }

    .tabs {
      margin-bottom: 0.05rem;

      .tab {
        color: #879099;

        &.active {
          color: #ff5526;
          font-weight: 500;
        }

        &::after {
          background: #ff5526;
        }
      }
    }

    .mid {
      .desc {
        color: #879099;
      }
    }

    .exchange-items {
      padding-right: 0;
    }

    .exchange-item {
      align-items: flex-end;

      .right {
        .btn {
          border: 0.01rem solid #ff7751;
        }
      }
    }
  }

  &.new-style {
    position: relative;
    padding: 0.16rem 0 0;
    margin-top: 0.12rem !important;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 0.89rem;
      background: #fff;
      background-image:
        linear-gradient(
          180deg,
          #fff 0%,
          #fcfcfd 81.25%,
          #f0f3f5 100%
        );
      border-radius: 0.16rem 0.16rem 0 0;
    }

    .exchange-header {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.16rem 0 0.18rem;
      margin-bottom: 0.14rem;
      z-index: 1;

      .header-title {
        width: auto;
        height: 0.22rem;
      }

      .my-coupon-btn {
        display: flex;
        align-items: center;
        font-size: 0.13rem;
        line-height: 0.17rem;
        color: #5a6066;
      }

      .arrow-icon {
        width: 0.12rem;
        height: 0.12rem;
        vertical-align: bottom;
      }
    }

    .more {
      margin: 0.15rem auto 0.05rem auto;
      color: #5a6066;
      background-color: #f0f3f5;
      border-radius: 0.32rem;
      width: 1.43rem;
      height: 0.26rem;
      line-height: 0.26rem;

      * {
        border-color: #999 !important;
      }

      .more-arrow-icon {
        position: relative;
        top: -0.02rem;
      }
    }

    .body {
      .tabs {
        padding: 0 0.16rem;
      }

      .tab.active {
        font-weight: 600;

        &::after {
          width: 0.16rem;
          height: 0.03rem;
          border-radius: 0.03rem;
          background-color: #242729;
        }
      }

      .exchange-items {
        padding: 0 0.12rem;

        .exchange-item {
          .left-container {
            .mid {
              .desc {
                color: #5a6066;
                font-family: PingFang SC, sans-serif;
              }
            }
          }

          .right {
            .title {
              font-family: PingFang SC, sans-serif;
              font-weight: 500;
              color: #ff5729;
            }

            .btn {
              background-color: #fff1db;
              border: none;

              img {
                display: none;
              }
            }
          }
        }
      }
    }

    /* stylelint-disable no-descending-specificity */
    .exchange-btn-left {
      display: flex;
      align-items: center;

      .exchange-btn-left-img {
        width: 0.16rem;
        height: 0.16rem;
      }

      .exchange-btn-left-money {
        line-height: normal !important;
      }
    }
    /* stylelint-enable no-descending-specificity */
  }

  &.pure-version {
    margin-top: 0 !important;

    &::before {
      background: transparent;
      background-image: none;
    }

    .shadow {
      background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #f0f3f5 100%);
    }
  }
}
</style>
